/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Ajouter à la commande",
  "i18n.additionalProducts.emotionalHook": "♥️ Très apprécié :",
  "i18n.additionalProducts.productDescription": "Description produit",
  "i18n.additionalProducts.showMore": "Plus d‘informations",
  "i18n.additionalProducts.title": "Accessoires adaptés",
  "i18n.button.addToCart": "Ajouter au panier",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Appliquer",
  "i18n.button.back": "Retour",
  "i18n.button.cancel": "Annuler",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Fermer",
  "i18n.button.continue": "Continuer",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Continuer",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Texte",
  "i18n.button.noChanges": "Sans SMART SORTED",
  "i18n.button.design": "",
  "i18n.button.photos": "Photos",
  "i18n.button.retry": "Relancer",
  "i18n.button.uploadPhotos": "Téléchargement photo(s)",
  "i18n.button.withSmartSorted": "Avec SMART SORTED",
  "i18n.button.withoutSmartSorted": "Sans SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pour une meilleure lisibilité, veuillez raccourcir le texte / ligne.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "La police de caractères choisie est trop large pour ce texte.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "La taille maximale possible de la police de caractères est atteinte pour ce texte.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "La taille minimale possible de la police de caractères est atteinte pour ce texte.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Veuillez insérer un retour à la ligne",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Veuillez continuer à écrire sur une deuxième ligne ou agrandissez le champ réservé au texte.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Veuillez vérifier votre texte. Cette police ne prend pas en charge tous les caractères.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pour plus de lisibilité, veuillez raccourcir le texte / ligne.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Veuillez agrandir le champ réservé au texte",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Cette étape ne peut être annulée",
  "i18n.dialog.deletePlaceholder.title": "Voulez-vous vraiment supprimer l’espace réservé?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "La résolution de cette image est trop faible afin d’imprimer le motif de manière optimale !",
  "i18n.dialog.smartSorted.message": "Avec SMART SORTED, vous montez votre puzzle de 1000 pièces de manière innovante et sans effort, même sans modèle.",
  "i18n.dialog.smartSorted.title": "Succès garanti avec ce puzzle",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Cliquez s’il vous plaît sur \"{{text}}\" pour modifier le titre de la boîte. ",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Le titre de la boîte n’a pas été modifié",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuer sans titre sur la boîte",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un espace réservé au texte n’a pas été modifié.",
    "Quelques espaces réservés aux textes n’ont pas été modifiés."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Champs réservés non modifiés",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Vous avez interrompu la création depuis un certain temps. Elle ne peut être poursuivie. Veuillez recommencer le processus de création.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Une photo n'a pu être téléchargée. Elle a été retirée de la zone de conception et de la galerie.",
  "i18n.error.imageLoadingError.title": "Erreur de téléchargement",
  "i18n.error.imageProvisionError.message": "Une ou plusieurs photos ne peuvent être traitées. Le type de média n'est probablement pas accepté.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Fichier \"{{reference1}}\" n'a pu être traité.",
  "i18n.error.imageSelectionError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.imageSizeLimitExceededError.message": "L’image que vous venez de télécharger est trop grande.\nVeuillez réduire l’image à moins de 180 mégapixels et la télécharger à nouveau.",
  "i18n.error.imageSizeLimitExceededError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.imageUploadError.message": "Un problème de connection s'est produit.Veuillez réessayer ultérieurement.",
  "i18n.error.imageUploadError.title": "Erreur lors du téléchargement photo.",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "La police de caratères ne peut être utilisée. Veuillez choisir une autre police.",
  "i18n.error.invalidCharConfigError.title": "Police non applicable",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Votre connexion internet semble avoir été interrompue. Vous pourrez continuer à concevoir votre produit dès que la connection a été rétablie.",
  "i18n.error.templateLoadingError.message": "Modèle \"{{ error.reference[0] }}\" n'a pu être téléchargé.\nVeuillez réessayer ultérieurement.",
  "i18n.error.templateLoadingError.title": "Erreur de téléchargement",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" a un type de média non accepté.",
  "i18n.error.unsupportedMediaTypeError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.uploadProductError.message": "Un ou plusieurs produits n'ont pu être transmis au serveur.\nVeuillez réessayer ultérieurement.",
  "i18n.error.uploadProductError.title": "Erreur de transfert",
  "i18n.error.zoomModeError.message": "Le texte de votre création précédente n’a pu être utilisé. Veuillez entrer un nouveau texte.",
  "i18n.error.zoomModeError.title": "Texte non adopté",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Prix",
  "i18n.price.reduction": "Vous économisez ",
  "i18n.price.total": "Prix total",
  "i18n.priceDisplay.times": [
    "{{value}} exemplaire à {{pricePerUnit}}",
    "{{value}} exemplaires à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Sélectionner accessoires",
  "i18n.progressOverlay.message.lines.one": "Nous vous remercions pour votre création.",
  "i18n.progressOverlay.message.lines.two": "Votre commande est en cours de traitement...",
  "i18n.template.insertText": "Entrez votre texte ici",
  "i18n.toolbox.image.title": "Editer photo",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 photo",
    "{{value}} photos"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Prévisualisation 3D ",
  "i18n.toolbox.productChooser.title": "Modifier produit",
  "i18n.toolbox.productChooser.triggerText": "Produit",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Traiter le texte",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleFrCH {
  public getPlural(n: number): number
  {
    const pluralForm = (n > 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
